export default __webpack_public_path__ + "static/media/changePhoneNumber.803cd86e.svg";